import React from 'react';
import { choose } from '../../utils/platform';
import { useProfile } from './useProfile';
import ProfileDesktop from './Profile.desktop';
import ProfileMobile from './Profile.mobile';
import '../../styles/people.css';

const ProfileView = choose(ProfileDesktop, ProfileMobile);

export default function Profile() {
  const vm = useProfile();
  return <ProfileView vm={vm} />;
}
